import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import DOMPurify from 'dompurify';

import htmx from 'htmx.org';

import '@/events';

import { initMalvertisingDetector } from '@/malvertising_detector';
import { initTracker } from '@/analytics/tracker';
import { initPaginationTracker } from '@/analytics/pagination_tracker';
import { initExperimentView } from './ab_test';
import { initPageComponent, initSharedComponents, initAnalytics } from './load_components';
import { yieldToMain } from '@/utils/timing';

async function init() {
    window.Alpine = Alpine;
    window.htmx = htmx;
    window.DOMPurify = DOMPurify; // TODO: remove once DOMPurify is used only in modules

    // Start as early as possible: the observed malvertising auto-redirects on load.
    initMalvertisingDetector();

    initExperimentView();

    // Must run before the async component loaders: window.sbTracker has to
    // exist (and the journal be drained) before any code below can call track().
    // The tracker runs in every environment; only the endpoint differs — dev
    // points at the local event-sink so events can be inspected, prod keeps the
    // relative same-origin default (the DEV branch is tree-shaken out).
    if (import.meta.env.DEV) {
        initTracker('http://127.0.0.1:5005/api/event');
    } else {
        initTracker();
    }

    // Global delegated click listener (SB-6636); reads window.sbTracker at click time, so ordering vs initTracker() is not load-bearing.
    initPaginationTracker();

    await initSharedComponents();
    await yieldToMain();
    await initPageComponent();
    await yieldToMain();
    await initAnalytics();
    await yieldToMain();

    Alpine.plugin(intersect);
    Alpine.plugin(collapse);
    Alpine.start();
}

init();
